import React, { FC, useRef, useState } from "react";
import listBoxStyles from "./listbox.module.css";
import clsx from "clsx";
import { HandleFiles, handleFiles } from "../../../../../Tools/Tools";

interface TListBoxInterface {
  onFileChange?: (filesData: HandleFiles, name: string) => Promise<void>;
  style: React.CSSProperties;
  name: string;
  children: React.ReactNode;
}

//eslint-disable-next-line
const TListBox: FC<TListBoxInterface> = ({ onFileChange, style, name, children }) => {
  const wrapperRef = useRef(null);

  const [isDragOver, setIsDragOver] = useState(false);

  const onDragEnter = () => setIsDragOver(true);

  const onDragLeave = () => setIsDragOver(false);

  const onDrop = async (e) => {
    e.preventDefault();
    setIsDragOver(false);
    if (!e?.dataTransfer?.files || e?.dataTransfer?.files?.length === 0) return;
    const filesData = await handleFiles(e.dataTransfer.files);
    onFileChange && onFileChange(filesData, name);
  };

  const onDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <div
      name={name}
      type="TListBox"
      ref={wrapperRef}
      className={clsx(listBoxStyles["drop-file-input"], { [listBoxStyles.dragover]: isDragOver })}
      onDragEnter={onDragEnter}
      onDragLeave={onDragLeave}
      onDragOver={onDragOver}
      onDrop={onDrop}
      style={{ ...style, inset: 0, zIndex: 1, position: "absolute", height: "unset" }}
    >
      {children}
    </div>
  );
};

export default TListBox;
